import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../components/partials/Breadcrumb";
import { BiCategory } from "react-icons/bi";
import { Link, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from 'yup';
import Badge from 'react-bootstrap/Badge';
import { Alerts, Coupons } from "../../../helpers";
import { CiEdit } from "react-icons/ci";
import { MdDelete } from "react-icons/md";
import Modal from 'react-bootstrap/Modal';
import ConfModal from "../../../components/cmp/ConfModal";




const breadcrumbs = [
    {
        id: 1,
        label: "Dashboard",
        link: "/",
    },
    {
        id: 2,
        label: "Coupons",
        link: "/app/post/categories",
    },
    {
        id: 3,
        label: "Create New",
        link: "/app/post/categories/create",
    },
];


const validateSchema = Yup.object().shape({
    code: Yup.string()
        .required('Code is required')
        .max(20, 'Code cannot exceed 20 characters'),

    discount_type: Yup.string()
        .oneOf(['percent', 'amount'], 'Invalid discount type')
        .required('Discount type is required'),

    discount_value: Yup.number()
        .typeError('Discount value must be a number')
        .required('Discount value is required')
        .positive('Discount value must be positive'),

    min_purchase: Yup.number()
        .typeError('Minimum purchase must be a number')
        .min(0, 'Minimum purchase cannot be negative')
        .required('Minimum purchase is required'),

    max_discount: Yup.number()
        .typeError('Max discount must be a number')
        .min(0, 'Max discount cannot be negative')
        .required('Max discount is required'),

    usage_limit: Yup.number()
        .typeError('Usage limit must be a number')
        .min(1, 'Usage limit must be at least 1')
        .required('Usage limit is required'),

    expires_at: Yup.date()
        .nullable()
        .required('Expiration date is required')
        .min(new Date(), 'Expiration date cannot be in the past'),

    is_active: Yup.boolean()
        .required('Status is required')
});

const formatDateForInput = (dateStr) => {
  const date = new Date(dateStr);
  // Convert to local time in YYYY-MM-DDTHH:MM format
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};


const CreateCoupons = () => {
    const [isLoading, setLoading] = useState(true);
    const [coupons, setCoupons] = useState([]);
    const [singleCoupon, setSingleCoupon] = useState(null);
    const [isEdit, setEdit] = useState(false);


    const handleSubmitCoupon = async (values, { setSubmitting, resetForm }) => {
        const resp = await Coupons.createCoupon(values);
        if (resp && resp.status) {
            setSubmitting(false);
            resetForm();
            getCoupons();
            Alerts.alertMessage(resp.message, 'top-right', 'success');
        } else {
            setSubmitting(false);
            Alerts.alertMessage(resp.message, 'top-right', 'error');
        }
    }

    const getCoupons = async () => {
        const resp = await Coupons.getCoupons();
        if (resp && resp.status) {
            setCoupons(resp.coupons);
            setLoading(false);
        }
    }

    useEffect(() => {
        getCoupons();
    }, []);

    const getSingleCoupon = (id) => {
        const coupon = coupons.find(el => el.id === parseInt(id));
        setSingleCoupon(coupon);
        setEdit(true)
    }
    const handleCloseEdit = () => {
        setSingleCoupon(null);
        setEdit(false)
    }

    const handleUpdateCoupon = async (values, { setSubmitting, resetForm }) => {
        const resp = await Coupons.updateCoupon(singleCoupon.id, values);
        if (resp && resp.status) {
            setSubmitting(false);
            handleCloseEdit();
            getCoupons();
            Alerts.alertMessage(resp.message, 'top-right', 'success');
        } else {
            setSubmitting(false);
            Alerts.alertMessage(resp.message, 'top-right', 'error');
        }
    }


    const handleDelete = async (id) => {
        const resp = await Coupons.deleteCoupon(id);
        if (resp && resp.status) {
            getCoupons();
            Alerts.alertMessage(resp.message, 'top-right', 'success');
        } else {
            Alerts.alertMessage(resp.message, 'top-right', 'error');
        }
    }

    return (
        <>

            <div className="innerPageWrapper">
                <div className="container-fluid">
                    <div className="page-title">
                        <h2>
                            <BiCategory /> Create Coupon
                        </h2>
                        <Link to="/app/posts" className="btn btn-success">
                            <BiCategory /> Coupon
                        </Link>
                    </div>
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-5">
                                    <Formik
                                        initialValues={{
                                            code: '',
                                            discount_type: 'percent',
                                            discount_value: '',
                                            min_purchase: '',
                                            max_discount: '',
                                            usage_limit: '',
                                            expires_at: '',
                                            is_active: true
                                        }}
                                        validationSchema={validateSchema}
                                        onSubmit={handleSubmitCoupon}
                                    >
                                        {({
                                            values,
                                            errors,
                                            touched,
                                            handleChange,
                                            handleBlur,
                                            handleSubmit,
                                            isSubmitting
                                        }) => (
                                            <form onSubmit={handleSubmit}>
                                                <div className="form-group row">
                                                    <div className="col-md-6">
                                                        <label>Code</label>
                                                        <input
                                                            type="text"
                                                            name="code"
                                                            placeholder="Code"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.code}
                                                            className="form-control"
                                                        />
                                                        {errors.code && touched.code && (
                                                            <span className="help-error">{errors.code}</span>
                                                        )}
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label>Discount Type</label>
                                                        <select
                                                            name="discount_type"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.discount_type}
                                                            className="form-control"
                                                        >
                                                            <option value="percent">Percent</option>
                                                            <option value="amount">Amount</option>
                                                        </select>
                                                        {errors.discount_type && touched.discount_type && (
                                                            <span className="help-error">{errors.discount_type}</span>
                                                        )}
                                                    </div>

                                                </div>

                                                <div className="form-group row">
                                                    <div className="col-md-6">
                                                        <label>Discount Value</label>
                                                        <input
                                                            type="number"
                                                            name="discount_value"
                                                            placeholder="Discount Value"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.discount_value}
                                                            className="form-control"
                                                        />
                                                        {errors.discount_value && touched.discount_value && (
                                                            <span className="help-error">{errors.discount_value}</span>
                                                        )}
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label>Min Purchase</label>

                                                        <input
                                                            type="number"
                                                            name="min_purchase"
                                                            placeholder="Min Purchase"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.min_purchase}
                                                            className="form-control"
                                                        />
                                                        {errors.min_purchase && touched.min_purchase && (
                                                            <span className="help-error">{errors.min_purchase}</span>
                                                        )}
                                                    </div>

                                                </div>

                                                <div className="form-group row">
                                                    <div className="col-md-6">
                                                        <label>Max Discount</label>
                                                        <input
                                                            type="number"
                                                            name="max_discount"
                                                            placeholder="Max Discount"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.max_discount}
                                                            className="form-control"
                                                        />
                                                        {errors.max_discount && touched.max_discount && (
                                                            <span className="help-error">{errors.max_discount}</span>
                                                        )}
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label>Uses Limit</label>
                                                        <input
                                                            type="number"
                                                            name="usage_limit"
                                                            placeholder="Usage Limit"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.usage_limit}
                                                            className="form-control"
                                                        />
                                                        {errors.usage_limit && touched.usage_limit && (
                                                            <span className="help-error">{errors.usage_limit}</span>
                                                        )}
                                                    </div>

                                                </div>

                                                <div className="form-group row">

                                                    <div className="col-md-6">
                                                        <label>Expire At</label>
                                                        <input
                                                            type="datetime-local"
                                                            name="expires_at"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.expires_at}
                                                            className="form-control"
                                                        />
                                                        {errors.expires_at && touched.expires_at && (
                                                            <span className="help-error">{errors.expires_at}</span>
                                                        )}
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label>
                                                            Status
                                                        </label>
                                                        <select
                                                            name="is_active"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.is_active}
                                                            className="form-control"
                                                        >
                                                            <option value={true}>Active</option>
                                                            <option value={false}>Unactive</option>
                                                        </select>
                                                    </div>

                                                </div>

                                                <button type="submit" disabled={isSubmitting} className="btn btn-primary">
                                                    {isSubmitting ? 'Please wait..' : 'Create Now'}
                                                </button>
                                            </form>
                                        )}
                                    </Formik>
                                </div>
                                <div className="col-md-7">
                                    {
                                        !isLoading && coupons.length > 0 && coupons.map((coupon, i) => {
                                            return <div className="card couponDetails" key={i} style={{ marginBottom: 10 }}>
                                                <div className="card-Header" ><h5>#{++i} Coupon details</h5> <div><button onClick={() => getSingleCoupon(coupon.id)}><CiEdit size={25} color="#fff" /></button> <ConfModal message={'Are you sure you want to delete this coupon !'} delId={coupon.id} handleDelete={handleDelete} /></div></div>
                                                <div className="card-body">

                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <p><span>Code</span> : {coupon.code}</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <p><span>Discount Type</span> : {coupon.discount_type}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <p><span>Discount Value</span> : 
                                                             {coupon.discount_type === 'amount' && `£ ${coupon.discount_value}`}  
                                                             {coupon.discount_type === 'percent' && `${parseInt(coupon.discount_value)}% `}</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <p><span>Min Purchase</span> : £ {coupon.min_purchase}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <p><span>Max Discount</span> : £ {coupon.max_discount}</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <p><span>Usage Limit</span> : {coupon.usage_limit}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <p><span>Used Count</span> : {coupon.used_count}</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <p><span>Status</span> : {coupon.is_active ? <Badge bg="success">Active</Badge> : <Badge bg="danger">Unactive</Badge>}</p>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <p><span>Expires At</span> : {
                                                                coupon.expires_at
                                                                    ? new Date(coupon.expires_at).toLocaleString('en-US', {
                                                                        year: 'numeric',
                                                                        month: 'short',
                                                                        day: '2-digit',
                                                                        hour: '2-digit',
                                                                        minute: '2-digit',
                                                                        hour12: false
                                                                    })
                                                                    : 'N/A'
                                                            }</p>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        })
                                    }
                                </div>
                            </div>
                            {
                                isEdit && singleCoupon !== null && <Modal
                                    show={isEdit}
                                    onHide={handleCloseEdit}
                                    size="md"
                                    backdrop="static"
                                    keyboard={false}
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title id="contained-modal-title-vcenter">
                                            Update Coupon
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body className='pd-50'>
                                        <Formik
                                            enableReinitialize={true}
                                            initialValues={{
                                                code: singleCoupon.code,
                                                discount_type: singleCoupon.discount_type,
                                                discount_value: singleCoupon.discount_value,
                                                min_purchase: singleCoupon.min_purchase,
                                                max_discount: singleCoupon.max_discount,
                                                usage_limit: singleCoupon.usage_limit,
                                                expires_at: singleCoupon.expires_at ? formatDateForInput(singleCoupon.expires_at) : '',
                                                is_active: singleCoupon.is_active
                                            }}
                                            validationSchema={validateSchema}
                                            onSubmit={handleUpdateCoupon}
                                        >
                                            {({
                                                values,
                                                errors,
                                                touched,
                                                handleChange,
                                                handleBlur,
                                                handleSubmit,
                                                isSubmitting
                                            }) => (
                                                <form onSubmit={handleSubmit}>
                                                    <div className="form-group row">
                                                        <div className="col-md-6">
                                                            <label>Code</label>
                                                            <input
                                                                type="text"
                                                                name="code"
                                                                placeholder="Code"
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values.code}
                                                                className="form-control"
                                                            />
                                                            {errors.code && touched.code && (
                                                                <span className="help-error">{errors.code}</span>
                                                            )}
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label>Discount Type</label>
                                                            <select
                                                                name="discount_type"
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values.discount_type}
                                                                className="form-control"
                                                            >
                                                                <option value="percent">Percent</option>
                                                                <option value="amount">Amount</option>
                                                            </select>
                                                            {errors.discount_type && touched.discount_type && (
                                                                <span className="help-error">{errors.discount_type}</span>
                                                            )}
                                                        </div>

                                                    </div>

                                                    <div className="form-group row">
                                                        <div className="col-md-6">
                                                            <label>Discount Value</label>
                                                            <input
                                                                type="number"
                                                                name="discount_value"
                                                                placeholder="Discount Value"
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values.discount_value}
                                                                className="form-control"
                                                            />
                                                            {errors.discount_value && touched.discount_value && (
                                                                <span className="help-error">{errors.discount_value}</span>
                                                            )}
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label>Min Purchase</label>

                                                            <input
                                                                type="number"
                                                                name="min_purchase"
                                                                placeholder="Min Purchase"
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values.min_purchase}
                                                                className="form-control"
                                                            />
                                                            {errors.min_purchase && touched.min_purchase && (
                                                                <span className="help-error">{errors.min_purchase}</span>
                                                            )}
                                                        </div>

                                                    </div>

                                                    <div className="form-group row">
                                                        <div className="col-md-6">
                                                            <label>Max Discount</label>
                                                            <input
                                                                type="number"
                                                                name="max_discount"
                                                                placeholder="Max Discount"
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values.max_discount}
                                                                className="form-control"
                                                            />
                                                            {errors.max_discount && touched.max_discount && (
                                                                <span className="help-error">{errors.max_discount}</span>
                                                            )}
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label>Uses Limit</label>
                                                            <input
                                                                type="number"
                                                                name="usage_limit"
                                                                placeholder="Usage Limit"
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values.usage_limit}
                                                                className="form-control"
                                                            />
                                                            {errors.usage_limit && touched.usage_limit && (
                                                                <span className="help-error">{errors.usage_limit}</span>
                                                            )}
                                                        </div>

                                                    </div>

                                                    <div className="form-group row">

                                                        <div className="col-md-6">
                                                            <label>Expire At</label>
                                                            <input
                                                                type="datetime-local"
                                                                name="expires_at"
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values.expires_at}
                                                                className="form-control"
                                                            />
                                                            {errors.expires_at && touched.expires_at && (
                                                                <span className="help-error">{errors.expires_at}</span>
                                                            )}
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label>
                                                                Status
                                                            </label>
                                                            <select
                                                                name="is_active"
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values.is_active}
                                                                className="form-control"
                                                            >
                                                                <option value={true} selected={values.is_active === true}>Active</option>
                                                                <option value={false} selected={values.is_active === false}>Unactive</option>
                                                            </select>
                                                        </div>

                                                    </div>

                                                    <button type="submit" disabled={isSubmitting} className="btn btn-primary">
                                                        {isSubmitting ? 'Please wait..' : 'Update Now'}
                                                    </button>
                                                </form>
                                            )}
                                        </Formik>
                                    </Modal.Body>

                                </Modal>
                            }

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreateCoupons;
